import type { ScoreBand, TrendLabel } from '@/types/insights';
import { TEMPERATURE_THRESHOLDS } from '@/config/scoringWeights';

/** Maps a -100..100 "temperature" style score to a qualitative label. */
export function temperatureBand(value: number | undefined): ScoreBand {
  if (value === undefined || Number.isNaN(value)) {
    return { value: 0, label: 'insufficient-data' };
  }
  let label: TrendLabel;
  if (value >= TEMPERATURE_THRESHOLDS.hot) label = 'hot';
  else if (value >= TEMPERATURE_THRESHOLDS.warming) label = 'warming';
  else if (value > TEMPERATURE_THRESHOLDS.cooling) label = 'neutral';
  else if (value > TEMPERATURE_THRESHOLDS.cold) label = 'cooling';
  else label = 'cold';
  return { value, label };
}

/** Maps a 0..100 "how much of X" style score (opportunity, risk, competition, confidence). */
export function magnitudeBand(value: number | undefined): ScoreBand {
  if (value === undefined || Number.isNaN(value)) {
    return { value: 0, label: 'insufficient-data' };
  }
  let label: TrendLabel;
  if (value >= 70) label = 'hot';
  else if (value >= 55) label = 'warming';
  else if (value > 45) label = 'neutral';
  else if (value > 30) label = 'cooling';
  else label = 'cold';
  return { value, label };
}
